import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Globe, Users, Trophy } from 'lucide-react';
import Footer from '../components/Footer';
import SponsorHero from '../components/sponsors/SponsorHero';
import MainSponsor from '../components/sponsors/MainSponsor';
import SponsorBenefits from '../components/sponsors/SponsorBenefits';
import ContactCTA from '../components/sponsors/ContactCTA';

export default function Sponsors() {
  const sponsor = {
    name: "TodoJuguete",
    logo: "https://todojuguete.es/img/todojuguete-logo-1541002131.jpg",
    description: "Tu tienda de juguetes de confianza",
    contribution: "Patrocinador oficial del concurso",
    website: "https://todojuguete.es"
  };

  const benefits = [
    {
      icon: Globe,
      title: "Visibilidad Global",
      description: "Alcance a miles de participantes y visitantes durante la temporada navideña"
    },
    {
      icon: Users,
      title: "Engagement",
      description: "Interacción directa con una audiencia altamente comprometida"
    },
    {
      icon: Trophy,
      title: "Prestigio",
      description: "Asociación con uno de los concursos navideños más importantes"
    }
  ];

  return (
    <>
      <Helmet>
        <title>Patrocinador Oficial - Concurso de Árboles de Navidad</title>
        <meta 
          name="description" 
          content="TodoJuguete, nuestro patrocinador oficial del concurso de árboles de Navidad." 
        />
        <link rel="canonical" href="https://arbolnavidad.com/patrocinadores" />
      </Helmet>

      <div className="min-h-screen pt-16">
        <SponsorHero />
        <MainSponsor sponsor={sponsor} />
        <SponsorBenefits benefits={benefits} />
        <ContactCTA />
        <Footer />
      </div>
    </>
  );
}